import { render, staticRenderFns } from "./whiteBoard.vue?vue&type=template&id=3446f574&scoped=true&"
import script from "./whiteBoard.vue?vue&type=script&lang=js&"
export * from "./whiteBoard.vue?vue&type=script&lang=js&"
import style0 from "./whiteBoard.vue?vue&type=style&index=0&id=3446f574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3446f574",
  null
  
)

export default component.exports